import React from "react";
import {
  Document,
  Page,
  Text,
  View,
  StyleSheet,
  Image
} from "@react-pdf/renderer";
import logo from "../../assets/logo.png";

// Estilos
const styles = StyleSheet.create({
  page: {
    padding: 30,
    fontSize: 12,
    fontFamily: "Helvetica",
    position: "relative",
  },
  section: {
    marginBottom: 12,
  },
  header: {
    flexDirection: "row",
    alignItems: "center",
    marginBottom: 20,
  },
  logo: {
    width: 160,
    height: 50,
    marginRight: 20,
  },
  title: {
    fontSize: 20,
    fontWeight: "bold",
    marginBottom: 16,
  },
  heading: {
    fontSize: 16,
    fontWeight: "bold",
    marginBottom: 6,
  },
  listItem: {
    marginLeft: 12,
    marginBottom: 4,
  },
  kpi: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: 4,
  },
  footer: {
    position: "relative",
    bottom: 0,
    left: 0,
    // right: 30,
    fontSize: 10,
    borderTopWidth: 1,
    borderColor: "#ccc",
    paddingTop: 8,
    flexDirection: "row",
    justifyContent: "space-between",
  },
});

// Subcomponente de bloques de texto
const TextBlock = ({ title, content }) => {
  if (!content) return null;

  return (
    <View style={styles.section}>
      <Text style={styles.heading}>{title}</Text>
      {Array.isArray(content) ? (
        content.map((item, idx) => (
          <Text key={idx} style={styles.listItem}>
            • {item}
          </Text>
        ))
      ) : (
        <Text>{content}</Text>
      )}
    </View>
  );
};

// Componente principal
const InsightPDF = ({ parsed, chartImage }) => {
  const {
    titulo_informe,
    kpis,
    alertas,
    otras_secciones,
    grafico,
    user,
    date,
    ...main
  } = parsed;

  return (
    <Document>
      {/* Aquí vamos a agregar múltiples páginas si el contenido es largo */}
      <Page size="A4" style={styles.page}>
        {/* Contenido principal con margen para evitar solaparse con el footer */}
        <View>
          {/* Encabezado con logo */}
          <View style={styles.header}>
            <Image src={logo} style={styles.logo} />
          </View>

          {/* Título del informe */}
          <Text style={styles.title}>{titulo_informe || "Informe"}</Text>

          {/* Secciones principales */}
          {Object.entries(main).map(([key, val]) => (
            <TextBlock
              key={key}
              title={key.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase())}
              content={val}
            />
          ))}

          {/* KPIs */}
          {kpis && (
            <View style={styles.section}>
              <Text style={styles.heading}>KPIs</Text>
              {Object.entries(kpis).map(([k, v]) => (
                <View key={k} style={styles.kpi}>
                  <Text>{k}</Text>
                  <Text>{v}</Text>
                </View>
              ))}
            </View>
          )}

          {/* Alertas */}
          {alertas && (
            <View style={styles.section}>
              <Text style={styles.heading}>Alertas</Text>
              {alertas.map((a, i) => (
                <Text key={i} style={styles.listItem}>
                  ⚠ {a}
                </Text>
              ))}
            </View>
          )}

          {/* Otras secciones */}
          {otras_secciones &&
            Object.entries(otras_secciones).map(([k, v]) => (
              <TextBlock key={k} title={k.replace(/_/g, " ")} content={v} />
            ))}

          {/* Imagen del gráfico */}
          {chartImage && (
            <View style={styles.section}>
              <Text style={styles.heading}>Gráfico de Consumo Energético</Text>
              <Image src={chartImage} style={{ width: "100%", height: 200 }} />
            </View>
          )}

          {/* Espaciador que evita superposición con footer */}
          <View style={{ height: 60 }} />
        </View>

        {/* Pie de página solo en la última página */}
        <View style={styles.footer} fixed>
          <Text>Usuario: {user || "Desconocido"}</Text>
          <Text
            render={({ pageNumber, totalPages }) =>
              `Página ${pageNumber} de ${totalPages}`
            }
          />
          <Text>Fecha: {date || "Sin fecha"}</Text>
        </View>
      </Page>
    </Document>
  );
};

export default InsightPDF;
